import React, { useEffect, useState } from 'react'
import { dataStates } from '@garpix/fetcher'
import Button from '@/components/Button'
import ContestWorkCard from '@/components/Cards/ContestWorkCard'
import Section from '@/components/Section'
import Title from '@/components/Title'
import { PlaceholderLoading } from '@/components/PlaceholderLoading'
import WorksSearch from './WorksSearch'
import { IPropsSearchForm, IPropsWorksContent } from '../interfaces'
import { dateParse, getOrderNumber } from '@/utils'
import style from '../styles/contest_detail.module.scss'

const WorksContent = ({
  activePage,
  filterParams = {},
  isNext,
  results = [],
  status = '',
  loadData = () => {},
  showMore = () => {}
}: IPropsWorksContent): React.ReactElement => {
  const [showWorks, setShowWorks] = useState(false)

  const search = (params?: IPropsSearchForm): void => {
    loadData(1, { ...filterParams, ...params })
  }

  useEffect(() => {
    const isLoading = status === dataStates.loading
    let isShow = false
    if (isLoading) {
      if (Number(activePage) === 1) {
        isShow = false
      }
      if (Number(activePage) > 1) {
        isShow = true
      }
    } else {
      isShow = true
    }
    setShowWorks(isShow)
  }, [status, filterParams, results])

  return (
    <Section>
      <div className={style.work_wrap}>
        <Title type='h2' theme='h3' className={style.work__title}>
          Работы на конкурсе
        </Title>
        <WorksSearch
          initValue={filterParams.q}
          inputDisabled={status === dataStates.loading}
          search={search}
        />
      </div>
      {showWorks
        ? (
          <ul className={style.work_results}>
            {results.map((el, index) => {
              const date = dateParse({
                date: el.date_create,
                format: 'DD.MM.YYYY'
              })
              const number = getOrderNumber({
                index,
                page: filterParams.page,
                pageSize: filterParams.page_size
              })
              return (
                <li key={el.id} className={style.work__item}>
                  <ContestWorkCard
                    image={el.preview_picture}
                    number={number}
                    author={el?.user?.name ?? ''}
                    date={date}
                  />
                </li>
              )
            })}
          </ul>
          )
        : null}
      {status === dataStates.loading
        ? (
          <ul className={style.work_results}>
            <li className={style.work__item}>
              <PlaceholderLoading shape='rect' width='100%' height='461' />
            </li>
            <li className={style.work__item}>
              <PlaceholderLoading shape='rect' width='100%' height='461' />
            </li>
            <li className={style.work__item}>
              <PlaceholderLoading shape='rect' width='100%' height='461' />
            </li>
            <li className={style.work__item}>
              <PlaceholderLoading shape='rect' width='100%' height='461' />
            </li>
          </ul>
          )
        : null}

      {results.length === 0 && status === dataStates.loaded
        ? (
          <p>К сожалению не удалось найти работы</p>
          )
        : null}
      {status === dataStates.failed
        ? (
          <p>Произошла ошибка загузки данных. Пожалуйста, попробуйте позже.</p>
          )
        : null}

      {isNext
        ? (
          <Button
            disabled={status === dataStates.loading}
            size='large'
            wide
            outline
            className={style.work__more}
            onClick={showMore}
          >
            Показать еще
          </Button>
          )
        : null}
    </Section>
  )
}

export default WorksContent
